export default function times(length) { return Array(length).fill().map((_, index) => index); }
